/* Product page behaviour (port of the prototype js/product.js onto real Shopify data):
   option chips -> variant, live price, gallery thumbs, zoom lightbox, size guide, sticky bar. */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const pdp = $('#pdp');
  const dataEl = $('#pdpData');
  if (!pdp || !dataEl) return;
  const product = JSON.parse(dataEl.textContent);

  // ---- money: honour the shop's money format (e.g. "£{{amount}}") ----
  const moneyFormat = pdp.dataset.moneyFormat || '£{{amount}}';
  const money = (cents) => {
    const n = (cents / 100);
    const withDec = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const noDec = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) =>
      k === 'amount_no_decimals' ? noDec :
      k === 'amount_with_comma_separator' ? withDec.replace('.', ',') : withDec);
  };

  // ---- option chips -> variant ----
  const idInput = $('#pdpVariantId');
  const buy = $('#pdpBuy'), buyLabel = $('#pdpBuyLabel'), buyPrice = $('#pdpBuyPrice');
  const price = $('#pdpPrice'), stickyPrice = $('#pdpStickyPrice'), stickyBuy = $('#pdpStickyBuy');
  // Current selection, one value per real Shopify option (seeded from the variant Liquid printed).
  const startVariant = product.variants.find(v => String(v.id) === idInput.value) || product.variants[0];
  const selected = startVariant ? startVariant.options.slice() : [];

  // Size values like "A5 with pockets" are shown as Size (A5) + Pockets (No / Yes).
  const baseOf = v => String(v).split(/ with /i)[0].trim();
  const hasPockets = v => /pocket/i.test(String(v));
  const sizeChip = pdp.querySelector('[data-size-index]');
  const sIdx = sizeChip ? +sizeChip.dataset.sizeIndex : -1;
  const sizeValues = sIdx < 0 ? [] : [...new Set(product.variants.map(v => v.options[sIdx]))];
  let sizeBase = sIdx < 0 ? null : baseOf(selected[sIdx]);
  let sizePockets = sIdx < 0 ? false : hasPockets(selected[sIdx]);
  const resolveSize = () => {
    if (sIdx < 0) return;
    selected[sIdx] = sizeValues.find(v => baseOf(v) === sizeBase && hasPockets(v) === sizePockets) || null;
    // grey out a pockets choice this size isn't made in
    pdp.querySelectorAll('[data-pockets]').forEach(c => {
      const want = c.dataset.pockets === 'yes';
      c.disabled = !sizeValues.some(v => baseOf(v) === sizeBase && hasPockets(v) === want);
    });
  };

  const findVariant = () => product.variants.find(v =>
    v.options.every((val, i) => val === selected[i]));

  let charmsBlocked = () => false;   // set by the charm picker below
  const render = () => {
    const v = findVariant();
    if (!v) {
      buy.disabled = true; if (stickyBuy) stickyBuy.disabled = true;
      buyLabel.textContent = 'Unavailable';
      return;
    }
    idInput.value = v.id;
    const txt = money(v.price);
    price.textContent = txt; buyPrice.textContent = txt;
    if (stickyPrice) stickyPrice.textContent = txt;
    buy.disabled = !v.available; if (stickyBuy) stickyBuy.disabled = !v.available;
    buyLabel.textContent = v.available ? 'Add to bag' : 'Sold out';
    if (v.available && charmsBlocked()) {
      buy.disabled = true; if (stickyBuy) stickyBuy.disabled = true;
      buyLabel.textContent = 'Choose your charms';
    }
    if (v.featured_image) showImage(v.featured_image.src);
    try {
      const url = new URL(location.href); url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url);
    } catch (e) {}
  };

  const pick = chip => {
    chip.parentElement.querySelectorAll('.chip').forEach(c => {
      c.classList.remove('is-selected'); c.setAttribute('aria-pressed', 'false');
    });
    chip.classList.add('is-selected'); chip.setAttribute('aria-pressed', 'true');
  };
  pdp.querySelectorAll('.chip[data-option-index]').forEach(chip => {
    chip.addEventListener('click', () => {
      pick(chip);
      selected[+chip.dataset.optionIndex] = chip.dataset.value;
      render();
    });
  });
  pdp.querySelectorAll('.chip[data-size-index]').forEach(chip => {
    chip.addEventListener('click', () => {
      if (chip.disabled) return;
      pick(chip);
      if ('base' in chip.dataset) {
        sizeBase = chip.dataset.base;
        // if this size isn't made with the current pockets choice, switch to the one that exists
        if (!sizeValues.some(v => baseOf(v) === sizeBase && hasPockets(v) === sizePockets)) {
          sizePockets = !sizePockets;
          const other = pdp.querySelector('[data-pockets="' + (sizePockets ? 'yes' : 'no') + '"]');
          if (other) pick(other);
        }
      } else {
        sizePockets = chip.dataset.pockets === 'yes';
      }
      resolveSize();
      render();
    });
  });
  resolveSize();

  // choices that don't change the variant (e.g. Hardware), sent with the order as a line-item property
  pdp.querySelectorAll('.chip[data-property]').forEach(chip => {
    chip.addEventListener('click', () => {
      pick(chip);
      const input = document.getElementById(chip.dataset.property);
      if (input) input.value = chip.dataset.value;
    });
  });

  // Different hardware from the photos: the customer picks their own charms (free, part of the journal)
  const charmPick = document.getElementById('pdpCharmPick');
  if (charmPick) {
    const hw = document.getElementById('pdpHardware'), out = document.getElementById('pdpCharms'), count = document.getElementById('pdpCharmCount');
    const max = +charmPick.dataset.max || 3, items = [...charmPick.querySelectorAll('.charmpick__item')];
    const chosen = [];
    charmsBlocked = () => !charmPick.hidden && chosen.length === 0;
    const sync = () => {
      const differs = hw.value !== charmPick.dataset.pictured;
      charmPick.hidden = !differs; out.disabled = !differs;
      out.value = chosen.join(', ');
      count.textContent = chosen.length + ' of ' + max + ' chosen';
      items.forEach(b => { const on = chosen.includes(b.dataset.charm); b.setAttribute('aria-pressed', String(on)); b.disabled = !on && chosen.length >= max; });
      render();
    };
    items.forEach(b => b.addEventListener('click', () => {
      const i = chosen.indexOf(b.dataset.charm);
      if (i >= 0) chosen.splice(i, 1); else if (chosen.length < max) chosen.push(b.dataset.charm);
      sync();
    }));
    pdp.querySelectorAll('.chip[data-property="pdpHardware"]').forEach(c => c.addEventListener('click', sync));
    const form = document.getElementById('pdpForm');
    if (form) form.addEventListener('submit', e => {
      if (charmsBlocked()) { e.preventDefault(); charmPick.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });
  }

  // ---- folio add-on: its own product, added to the bag with the journal in the journal's size ----
  const folioBox = $('#pdpFolio'), folioData = $('#pdpFolioData');
  if (folioBox && folioData) {
    const folio = JSON.parse(folioData.textContent);
    const names = (folio.options || []).map(o => (o && o.name) || String(o));
    const fSize = names.findIndex(n => /size/i.test(n)), fFab = names.findIndex(n => /fabric|design|pattern/i.test(n));
    const note = $('#pdpFolioNote'), chips = [...folioBox.querySelectorAll('[data-folio]')];
    let fabric = '';
    const variantFor = f => folio.variants.find(v =>
      (fSize < 0 || sizeBase == null || v.options[fSize] === sizeBase) && (fFab < 0 || v.options[fFab] === f));
    const update = () => {
      chips.forEach(c => { if (c.dataset.folio) { const v = variantFor(c.dataset.folio); c.disabled = !v || !v.available; } });
      const cur = chips.find(c => c.dataset.folio === fabric);
      if (fabric && (!cur || cur.disabled)) { fabric = ''; pick(chips[0]); }
      const v = fabric && variantFor(fabric);
      note.hidden = !v;
      if (v) note.textContent = '+ ' + money(v.price) + ' for the folio' + (sizeBase ? ' (' + sizeBase + ')' : '');
    };
    chips.forEach(c => c.addEventListener('click', () => { if (c.disabled) return; pick(c); fabric = c.dataset.folio; update(); }));
    pdp.addEventListener('click', e => { if (e.target.closest('[data-size-index]')) update(); });
    update();
    const form = document.getElementById('pdpForm');
    if (form) form.addEventListener('submit', e => {
      const v = fabric && variantFor(fabric);
      if (e.defaultPrevented || !v) return;
      e.preventDefault();
      const fd = new FormData(form), props = {};
      for (const [k, val] of fd) { const m = k.match(/^properties\[(.+)\]$/); if (m && val !== '') props[m[1]] = val; }
      const items = [{ id: +fd.get('id'), quantity: +(fd.get('quantity') || 1), properties: props }, { id: v.id, quantity: 1 }];
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) })
        .then(r => { if (!r.ok) throw new Error('add failed'); location.href = '/cart'; })
        .catch(() => form.submit());   // fall back to adding the journal on its own
    });
  }

  // ---- gallery + lightbox ----
  const frame = $('#pdpMainFrame'), main = $('#pdpMain'), thumbs = $('#pdpThumbs');
  const lb = $('#lightbox'), lbImg = $('#lightboxImg'), lbClose = $('#lightboxClose');
  const sized = (src, w) => {
    try { const u = new URL(src, location.href); u.searchParams.set('width', w); return u.toString(); }
    catch (e) { return src; }
  };
  let full = frame ? frame.dataset.full : '';

  function showImage(src, fullSrc) {
    if (!main) return;
    main.removeAttribute('srcset');
    main.src = sized(src, 1100);
    full = fullSrc || sized(src, 1600);
    if (thumbs) thumbs.querySelectorAll('.thumb').forEach(t => {
      const same = t.dataset.src && sized(t.dataset.src, 1).split('?')[0] === sized(src, 1).split('?')[0];
      t.classList.toggle('is-active', same);
    });
  }

  if (thumbs) thumbs.querySelectorAll('.thumb').forEach(t =>
    t.addEventListener('click', () => showImage(t.dataset.src, t.dataset.full)));

  if (main && lb) {
    main.style.cursor = 'zoom-in';
    const openLb = () => {
      lbImg.src = full || main.currentSrc || main.src;
      lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden'; lbClose.focus();
    };
    const closeLb = () => {
      lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = ''; main.focus && main.focus();
    };
    main.addEventListener('click', openLb);
    lbClose.addEventListener('click', closeLb);
    lb.addEventListener('click', e => { if (e.target === lb) closeLb(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && lb.classList.contains('is-open')) closeLb(); });
  }

  // ---- size guide ----
  const sgBtn = $('.sizeguide__toggle'), sgPanel = $('#sizeGuidePanel');
  if (sgBtn && sgPanel) sgBtn.addEventListener('click', () => {
    const open = sgPanel.hidden;
    sgPanel.hidden = !open;
    sgBtn.classList.toggle('is-open', open);
    sgBtn.setAttribute('aria-expanded', String(open));
  });

  // ---- sticky add-to-bag: show once the main button scrolls away ----
  const sticky = $('#pdpSticky');
  if (sticky && buy && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => {
      sticky.classList.toggle('is-visible', !e.isIntersecting);
      sticky.setAttribute('aria-hidden', String(e.isIntersecting));
    }, { rootMargin: '0px 0px -40px 0px' }).observe(buy);
  }
  // No initial render(): Liquid already printed the selected variant's state.
  // arriving from a filtered journals page (?size=A5): pre-select that size
  try {
    const want = new URLSearchParams(location.search).get('size');
    if (want && sIdx >= 0) {
      const chip = [...pdp.querySelectorAll('.chip[data-base]')].find(c => c.dataset.base.toUpperCase() === want.toUpperCase());
      if (chip && !chip.classList.contains('is-selected')) chip.click();
    }
  } catch (e) {}
  // Start on "None" for add-ons (unless a specific variant was linked), if that combination exists.
  try {
    if (!new URLSearchParams(location.search).get('variant')) {
      const none = pdp.querySelector('.chip[data-option-index][data-value="None"], .chip[data-option-index][data-value="0"]');
      if (none && !none.classList.contains('is-selected')) {
        const i = +none.dataset.optionIndex;
        const exists = product.variants.some(v => v.options.every((val, k) => (k === i ? val === none.dataset.value : val === selected[k])));
        if (exists) none.click();
      }
    }
  } catch (e) {}
})();
